import { types, Instance, flow, toGenerator } from 'mobx-state-tree';
import { getSubscription } from '@/services/api/subscriptionApi';

export type ISubscriptionStore = Instance<typeof SubscriptionStore>;

const SubscriptionStore = types
  .model('SubscriptionStore', {
    isLoading: false,
  })
  .volatile(() => ({
    isSubscribed: false,
  }))
  .actions((self) => ({
    checkSubscription: flow(function* () {
      self.isLoading = true;
      try {
        const response = yield* toGenerator(getSubscription());
        self.isSubscribed = response.data?.is_subscribed ?? false;
      } catch (err) {
        console.error('[SubscriptionStore] Failed to check subscription:', err);
        self.isSubscribed = false;
      } finally {
        self.isLoading = false;
      }
    }),
  }));

export default SubscriptionStore;
